export default __webpack_public_path__ + "static/media/abe.b267e9be.JPG";